exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-feedback-group-button{justify-items:right}.ellipsis-block-code{white-space:nowrap;overflow:hidden;max-width:12ch;text-overflow:ellipsis;display:block}.admin-assign-group-left-header{min-height:61px;display:flex;align-items:center}.feedback-groups-left-header{display:flex;justify-content:space-between}.feedback-groups-alert{margin-bottom:0px !important}.feedback-groups-name{padding-left:18px}\n", ""]);

// exports
